/** Kanal tipi → müşteri hizmetleri UI (Telegram / WhatsApp / Web) */

/** Robbot primary — avatar arka planı */
export const CF_BRAND = {
  color: "#663f5c",
  light: "rgba(102, 63, 92, 0.12)",
};

const BRANDS = {
  telegram: {
    label: "Telegram",
    icon: "mdi-telegram",
    color: "#229ED9",
    light: "rgba(34, 158, 217, 0.12)",
    gradient: "#229ED9",
  },
  whatsapp: {
    label: "WhatsApp",
    icon: "mdi-whatsapp",
    color: "#25D366",
    light: "rgba(37, 211, 102, 0.12)",
    gradient: "#25D366",
  },
  web: {
    label: "Web",
    icon: "mdi-web",
    color: "#663f5c",
    light: "rgba(102, 63, 92, 0.12)",
    gradient: "#663f5c",
  },
};

export function getChannelBrand(type) {
  const key = String(type || "").toLowerCase();
  return BRANDS[key] || {
    label: type || "Kanal",
    icon: "mdi-forum",
    color: CF_BRAND.color,
    light: CF_BRAND.light,
    gradient: CF_BRAND.color,
  };
}

export function sessionContactName(session) {
  const c = session?.contact;
  if (c?.displayName) return c.displayName;
  if (c?.primaryEmail) return c.primaryEmail;
  if (c?.telegramChatId) return `Telegram ${c.telegramChatId}`;
  const ext = session?.externalUserId;
  if (!ext) return "Misafir kullanıcı";
  if (String(ext).length > 14) return `Kullanıcı …${String(ext).slice(-6)}`;
  return `Kullanıcı ${ext}`;
}

export function sessionInitials(session) {
  const name = sessionContactName(session);
  const parts = name.replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ0-9\s]/g, " ").trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return (name[0] || "?").toUpperCase();
}

export function statusLabelTr(status) {
  const s = String(status || "").toLowerCase();
  if (s === "active") return "Aktif";
  if (s === "completed" || s === "ended") return "Tamamlandı";
  if (s === "error") return "Hata";
  return status || "—";
}
